export default __webpack_public_path__ + "static/media/profile_view_teal.7f0dab47.svg";